import { render, staticRenderFns } from "./MoreAboutBusiness.vue?vue&type=template&id=eeea0746&scoped=true&"
import script from "./MoreAboutBusiness.vue?vue&type=script&lang=js&"
export * from "./MoreAboutBusiness.vue?vue&type=script&lang=js&"
import style0 from "./MoreAboutBusiness.vue?vue&type=style&index=0&id=eeea0746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeea0746",
  null
  
)

export default component.exports